import { useIntl as useReactIntl } from 'react-intl'

export const useIntl = () => {
    const intl = useReactIntl()

    const t = (message, values) => intl.formatMessage({ id: message }, values)

    const formatNumber = (value, options) => intl.formatNumber(value, options)

    const formatDate = (value, options) => intl.formatDate(value, options)

    const formatList = (value, options) => intl.formatList(value, options)

    const formatPlural = (value, options) => intl.formatPlural(value, options)

    const formatRelativeTime = (value, unit, options) =>
        intl.formatRelativeTime(value, unit, options)

    const formatTime = (value, options) => intl.formatTime(value, options)

    return {
        t,
        formatNumber,
        formatDate,
        formatList,
        formatPlural,
        formatRelativeTime,
        formatTime,
    }
}
